'use strict';

import './TileChoice.less';

import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

export default class TileChoice extends React.Component {
	render() {
		const classes = classnames('TileChoice', this.props.className);

		return (
			<div
				className={classes}
				key={this.props.id}
				id={this.props.id}
				onClick={this.props.handleClick}
			>
				{this.props.image}
				<div className="name">{this.props.name}</div>
				<div className="description">{this.props.description}</div>
			</div>
		);
	}
}

TileChoice.propTypes = {
	id: PropTypes.string.isRequired,
	image: PropTypes.node,
	handleClick: PropTypes.func,
	name: PropTypes.string,
	description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	className: PropTypes.string
};
